"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Jumbotron = _interopRequireDefault(require("@sprinx/react-web/Jumbotron"));

var _JumbotronSlide = _interopRequireDefault(require("@sprinx/react-web/JumbotronSlide"));

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _useBannerSizeCode = _interopRequireDefault(require("../../../components/useBannerSizeCode"));

var _useBanners = _interopRequireDefault(require("../../../components/useBanners"));

var _MediaSelectorBanner = _interopRequireDefault(require("../../../components/MediaSelectorBanner"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 2
    },
    comercial: {
      '& .react-swipeable-view-container': {
        height: 'auto !important'
      }
    },
    slide: {
      height: 'auto',
      '& > img': {
        width: '100%'
      }
    },
    activeBtn: {
      backgroundColor: theme.palette.primary.main
    },
    skeleton: (0, _defineProperty2.default)({
      width: 1232,
      height: 'calc(100vw / 3.74)',
      maxHeight: 329
    }, theme.breakpoints.down('sm'), {
      height: 'calc(100vw / 1.32)',
      maxHeight: 676.6
    }),
    box: {
      display: 'flex',
      flexGrow: 1
    }
  };
}, {
  name: 'SxHomepageJumbotron'
});
var sizes = {
  xs: 'mediumLF',
  sm: 'mediumLF',
  md: 'original',
  lg: 'original',
  xl: 'original'
};

function HomepageJumbotron(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  var bannerSizeCode = (0, _useBannerSizeCode.default)(sizes);
  var banners = (0, _useBanners.default)('homepageJumbo', bannerSizeCode);
  return typeof banners !== 'undefined' && (banners === null || banners === void 0 ? void 0 : banners.length) > 0 ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_Jumbotron.default, {
    className: classes.comercial,
    size: "s40",
    autoplayInterval: 10000,
    pagination: true,
    PaginationProps: {
      pagintaionDotProps: {
        classes: {
          active: classes.activeBtn
        }
      }
    }
  }, (banners || []).map(function (_ref2, idx) {
    var media = _ref2.media;
    var Wrapper = media[0].href ? function (p) {
      return /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({}, p, {
        component: "a",
        target: "_blank",
        href: media[0].href
      }));
    } : function (_ref3) {
      var c = _ref3.children;
      return c;
    };
    return /*#__PURE__*/_react.default.createElement(_JumbotronSlide.default, {
      size: "auto",
      key: idx.toString(),
      className: classes.slide
    }, /*#__PURE__*/_react.default.createElement(Wrapper, {
      component: "a",
      href: media[0].href
    }, /*#__PURE__*/_react.default.createElement(_MediaSelectorBanner.default, {
      src: media[0].src,
      alt: media[0].alt,
      size: bannerSizeCode,
      type: media[0].type
    })));
  }))) : /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.box
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    className: classes.skeleton,
    animation: "wave"
  }));
}

process.env.NODE_ENV !== "production" ? HomepageJumbotron.propTypes = {
  classes: _propTypes.default.shape({
    activeBtn: _propTypes.default.string,
    box: _propTypes.default.string,
    comercial: _propTypes.default.string,
    root: _propTypes.default.string,
    skeleton: _propTypes.default.string,
    slide: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
HomepageJumbotron.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = HomepageJumbotron;
exports.default = _default;